import React from 'react'
import {useDashboardController} from './DashboardController'
import {DashboardView} from './DashboardView'

const DashboardPage: React.FC = () => {
    const controller = useDashboardController()
    return <DashboardView {...controller} />
}

export default DashboardPage